module.exports = __webpack_public_path__ + "static/img/50_hsd.f50c4fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/50_hsd.png
// module id = fjxO
// module chunks = 2